import React from 'react';

// SVGs próprios para os cards da Visão Geral do Agro. Inspirados no protótipo
// da Amanda (gota, escudo+ e nuvem de chuva). Tracos com `currentColor` para
// permitir tematizar via CSS.

interface IconProps {
  size?: number;
  className?: string;
  title?: string;
}

function svgBase({
  size = 22,
  className,
  title,
  children,
}: IconProps & { children: React.ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-label={title}
    >
      {children}
    </svg>
  );
}

export function DropIcon(props: IconProps) {
  return svgBase({
    ...props,
    children: (
      <>
        <path d="M12 2.7C12 2.7 5.5 9.8 5.5 14a6.5 6.5 0 0 0 13 0c0-4.2-6.5-11.3-6.5-11.3z" />
        <path
          d="M9 14a3 3 0 0 0 2.5 3"
          opacity={0.6}
        />
      </>
    ),
  });
}

export function ShieldPlusIcon(props: IconProps) {
  return svgBase({
    ...props,
    children: (
      <>
        <path d="M12 2.5l-7.5 3v6.5c0 5 4.4 8.4 7.5 9.5 3.1-1.1 7.5-4.5 7.5-9.5V5.5L12 2.5z" />
        <line x1="12" y1="8.5" x2="12" y2="14.5" />
        <line x1="9" y1="11.5" x2="15" y2="11.5" />
      </>
    ),
  });
}

export function CloudRainIcon(props: IconProps) {
  return svgBase({
    ...props,
    children: (
      <>
        <path d="M7 16h10a4 4 0 0 0 .6-7.96A6 6 0 0 0 6 9.5 4 4 0 0 0 7 16z" />
        <line x1="8" y1="18.5" x2="7" y2="21.5" />
        <line x1="12" y1="18.5" x2="11" y2="21.5" />
        <line x1="16" y1="18.5" x2="15" y2="21.5" />
      </>
    ),
  });
}

export function SearchIcon({ size = 16, className, title }: IconProps) {
  return svgBase({
    size,
    className,
    title,
    children: (
      <>
        <circle cx="11" cy="11" r="7" />
        <line x1="20" y1="20" x2="16.5" y2="16.5" />
      </>
    ),
  });
}

// InfoIcon (ⓘ em traço) foi removido em 10/08/2026 — os pontos de metodologia
// usam o botão circular InfoButton (FontAwesome faInfo, padrão do Flux).
